import { images } from "../assets/images/index";

export default [
  {
    title: "Navigation",
    name: "navigation",
    sources: { selected: images.gpsOn }
  },
  {
    title: "Remote start",
    name: "remote start",
    sources: { selected: images.controllerOn }
  },
  {
    title: "Back up camera",
    name: "back up camera",
    sources: { selected: images.recordOn }
  },
  {
    title: "Audit input",
    name: "audit input",
    sources: { selected: images.audioOn }
  },
  {
    title: "USB",
    name: "usb",
    sources: { selected: images.usbOn }
  },
  {
    title: "Bluetooth",
    name: "bluetooth",
    sources: { selected: images.bluetoothOn }
  },
  {
    title: "Pet friendly",
    name: "pet friendly",
    sources: { selected: images.medalOn }
  },
  {
    title: "Convertible",
    name: "convertible",
    sources: { selected: images.cabrioletOn }
  },
  {
    title: "Sunroof",
    name: "sunroof",
    sources: { selected: images.carOn }
  },
  {
    title: "Heated seats",
    name: "heated seats",
    sources: { selected: images.heatOn }
  },
  {
    title: "Snow tires",
    name: "snow tires",
    sources: { selected: images.tireOn }
  },
  {
    title: "All-wheel drive",
    name: "all-wheel drive",
    sources: { selected: images.chassisOn }
  }
];
